module.exports = __webpack_public_path__ + "img/mediumRain.45e5d1de.svg";